import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getPublishedAnnouncements,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { PublishedPages } from '../../components/PublishedPages';

export const PublishedAnnoucements = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Announcements'
      }
    ]);
  }, []);
  return <PublishedPages {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  publishedPages: state.getIn([NS, 'publishedAnnouncements']),
  pending: state.getIn([NS, 'pending', 'publishedAnnouncements']),
  canEdit: state.getIn([NS, 'team', 'is_member'], false)
});
const mapDispatchToProps = dispatch => ({
  getPublishedPages: serviceHandle =>
    dispatch(getPublishedAnnouncements(serviceHandle)),
  updateCrumbs: crumbs => dispatch(updateCrumbs(crumbs))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishedAnnoucements);
